;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import ShowRow from "@/components/ShowRow/ShowRow";
import { ShowRowContent } from "@/lib/types/api/show-data";

interface FeaturedShowsRowProps {
  shows: ShowRowContent[];
  showMyStationBadge?: boolean;
}

const FeaturedShowsRow = (props: FeaturedShowsRowProps) => {
  const { shows, showMyStationBadge } = props;

  return (
    <ShowRow
      shows={shows}
      showMyStationBadge={showMyStationBadge}
      title={'Featured Shows'}
    data-sentry-element="ShowRow" data-sentry-component="FeaturedShowsRow" data-sentry-source-file="FeaturedShowsRow.tsx" />
  )
}

export default FeaturedShowsRow;
